import { SVGProps } from 'react'

export const ArrowRight = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8134 5L21 12.1866L13.8134 19.3733L12.7707 18.3306L18.1774 12.9239H3V11.4494H18.1774L12.7707 6.04266L13.8134 5Z"
      fill="currentColor"
    />
  </svg>
)

